const START = 0;
const DOTDOTDOT = '...';
const DOTDOTDOT_LENGTH = DOTDOTDOT.length;

export default function ellipsis(val: string, length: number): string {
  return val.length > length ? val.substr(START, length - DOTDOTDOT_LENGTH) + DOTDOTDOT : val;
}
